import { action, extendObservable, reaction } from "mobx";

class DigitalTicketsIdsStore {
  constructor(authStore, commonStore, compTixApi, routerStore, loadingStore) {
    this.authStore = authStore;
    this.commonStore = commonStore;
    this.compTixApi = compTixApi;
    this.routerStore = routerStore;
    this.loadingStore = loadingStore;

    this.defaults = {
      showDigitalTicketsIdsModal: false,
      request: {},
      digitalTicketDelivery: []
    };

    extendObservable(this, {
      showDigitalTicketsIdsModal: this.defaults["showDigitalTicketsIdsModal"],
      request: this.defaults["request"],
      requestId: this.defaults["requestId"],
      digitalTicketDelivery: this.defaults["digitalTicketDelivery"],

      setShowDigitalTicketsIdsModal: action(value => {
        this.showDigitalTicketsIdsModal = value;
      }),
      setDigitalTicketDelivery: action(value => {
        this.setDigitalTicketDelivery = value;
      }),
      setRequest: action(value => {
        this.request = value;
        const ticketStatus = this.request?.digitalTicketDelivery?.status;
        this.setDigitalTicketDelivery = this.request.digitalTicketDelivery.ticketIds.map(t => {
          return { ticketId: t, status: ticketStatus };
        });
      })
    });
  }
}

export default DigitalTicketsIdsStore;
